import { render, staticRenderFns } from "./search-form.vue?vue&type=template&id=a1bba4c0&scoped=true"
import script from "./search-form.vue?vue&type=script&lang=js"
export * from "./search-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1bba4c0",
  null
  
)

export default component.exports